import { PublicAgendaSchema } from "../../models/agenda.schema";

export const AgendaControllerResponseSchema = {
  listPublicAgendas: PublicAgendaSchema.array(),

  getPublicAgenda: PublicAgendaSchema.nullable(),
};
